export const setGamesData = (payload) => {
    return {
        type: 'SET_GAME_DATA',
        payload: payload
    }
}

